
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.567 3.227s.405.99.405 2.744c.405.224.9.27.9.27h4.363l1.215.314v.45l-.405.27H8.872v.45s-.18.225-.45.225-.495-.225-.495-.225v-.45l-.225 3.104h1.44l.135 1.17h-1.62l-.135.224h-.044l-.135-.224h-1.62l.135-1.17h1.44l-.225-3.104v.45s-.225.225-.495.225-.45-.225-.45-.225v-.45H.955l-.405-.27v-.45l1.215-.315h4.363s.495-.045.9-.27c.135-1.799.54-2.743.54-2.743z"}})])
          )
        }
      }
    